import Logo from "../../images/Logo.png";

function Header() {
  return (
    <header
      className=" shadow-sm py-4 px-9"
      style={{
        backgroundColor: "#0693e3",
        height: "100px",
      }}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        {/* Logo */}
        <div className="flex-shrink-0 justify-start">
          <img src={Logo} alt="Qbicles Logo" className="h-14 w-auto" />
        </div>

        {/* Navigation Links - Hidden on mobile */}
        {/* <nav className="hidden md:flex space-x-8">
                    <a href="#" className="text-white hover:text-gray-900 text-xl">Business Types</a>
                    <a href="#" className="text-white hover:text-gray-900 text-xl">Business Tools</a>
                    <a href="#" className="text-white hover:text-gray-900 text-xl">About</a>
                    <a href="#" className="text-white hover:text-gray-900 text-xl">Resources</a>
                </nav> */}

        {/* Get Started Button - Visible on all screens */}
        <button className="bg-white text-blue-500 px-6 py-2 rounded-md text-sm">
          GET STARTED
        </button>
      </div>
    </header>
  );
}

export default Header;
